import { baseStagingEnvironment } from './environment.baseStaging';

export const environment = {
    ...baseStagingEnvironment,
    envName: 'qa3',
    production: false,
    apiUrl: 'https://qa3.api.icamppro.com/api/v1',
    loadBalancerApiUrl: 'https://qa3-backend.api.icamppro.com/api/v1',
    assetPrefix: '/gateway/54a6bcd', // modified during aws build, this blank value must stay here
};
